var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBooking(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.19692 14.5525H5.93176V11.8432C5.93176 11.2658 6.15384 10.9549 6.65128 10.8927H8.2058C8.45045 10.8725 8.69658 10.9058 8.92701 10.9904C9.15745 11.0751 9.36665 11.209 9.54003 11.3828C9.71341 11.5566 9.84678 11.7661 9.93085 11.9967C10.0149 12.2274 10.0477 12.4736 10.0268 12.7182C10.0268 13.873 9.32949 14.5614 8.2058 14.5614L8.19692 14.5525ZM5.92732 7.22852V6.51788C5.92732 5.89608 6.19381 5.59406 6.7712 5.55852H7.93487C8.92976 5.55852 9.5338 6.15368 9.5338 7.15746C9.5338 7.91251 9.12518 8.8008 7.97928 8.8008H5.9362L5.92732 7.22852ZM11.0972 9.93782L10.6886 9.70687L11.0439 9.39596C11.4614 9.04064 12.1543 8.23229 12.1543 6.84211C12.1543 4.7102 10.502 3.33334 7.94819 3.33334H4.70591C4.33979 3.34592 3.99267 3.49938 3.73696 3.76171C3.48125 4.02404 3.33671 4.37497 3.3335 4.74129V16.8221H8.00593C10.8485 16.8221 12.6784 15.2765 12.6784 12.8781C12.6784 11.5901 12.0877 10.4797 11.0883 9.9245",
    fill: "#000000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4155 15.201C13.4155 14.2994 14.1395 13.571 15.0367 13.571C15.9338 13.571 16.6667 14.2994 16.6667 15.201C16.6667 16.1026 15.9383 16.831 15.0367 16.831C14.135 16.831 13.4155 16.1026 13.4155 15.201Z",
    fill: "#000000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBooking);
export default __webpack_public_path__ + "static/media/icon-booking.5752576f.svg";
export { ForwardRef as ReactComponent };